var map = {
	"./ar.json": 28797,
	"./cn.json": 71931,
	"./de.json": 34908,
	"./en.json": 27960,
	"./es.json": 29353,
	"./fa.json": 73708,
	"./fr.json": 58865,
	"./hi.json": 73180,
	"./hk.json": 94746,
	"./in.json": 16618,
	"./ja.json": 85521,
	"./ka.json": 45076,
	"./kk.json": 44049,
	"./km.json": 63017,
	"./ko.json": 98623,
	"./ku_IQ.json": 50323,
	"./ku_TR.json": 57751,
	"./ky.json": 32883,
	"./pt.json": 11093,
	"./ru.json": 30782,
	"./th.json": 54906,
	"./tr.json": 2067,
	"./ur.json": 98823,
	"./vi.json": 21304,
	"locales/lang/ar.json": 28797,
	"locales/lang/cn.json": 71931,
	"locales/lang/de.json": 34908,
	"locales/lang/en.json": 27960,
	"locales/lang/es.json": 29353,
	"locales/lang/fa.json": 73708,
	"locales/lang/fr.json": 58865,
	"locales/lang/hi.json": 73180,
	"locales/lang/hk.json": 94746,
	"locales/lang/in.json": 16618,
	"locales/lang/ja.json": 85521,
	"locales/lang/ka.json": 45076,
	"locales/lang/kk.json": 44049,
	"locales/lang/km.json": 63017,
	"locales/lang/ko.json": 98623,
	"locales/lang/ku_IQ.json": 50323,
	"locales/lang/ku_TR.json": 57751,
	"locales/lang/ky.json": 32883,
	"locales/lang/pt.json": 11093,
	"locales/lang/ru.json": 30782,
	"locales/lang/th.json": 54906,
	"locales/lang/tr.json": 2067,
	"locales/lang/ur.json": 98823,
	"locales/lang/vi.json": 21304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5677;